module.exports = __webpack_public_path__ + "img/pool.155ddc4c.jpg";